import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
export default function Logout() {
  let navigate = useNavigate();

  let { logoutUser } = useContext(AuthContext);
  useEffect(() => {
    logoutUser();
    // navigate("/login");
  }, []);

  return null;
}
